export default "__VITE_PUBLIC_ASSET__3b154b77__"